import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const galleryImages = [{
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/WhatsApp-Image-2026-07-09-at-15.48.15.jpeg?v=9iux2dfmw74",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Final-Album-Cover-AAOM-scaled.png?v=7y67ujqne5",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Final-Album-Cover-AAOM-scaled.png?v=g0hzyh2bzc6",
  alt: "Smithfield photo",
  caption: "SMITHFIELD - SHORT FILM",
  credits: "Soundtrack - Sound Design - Mixing - Dialogue Cleanup",
  link: "https://www.imdb.com/title/tt44017435/?ref_=fn_t_1"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/08/WhatsApp-Image-2026-08-10-at-10.50.47.jpeg",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/08/WhatsApp-Image-2026-08-10-at-10.50.47.jpeg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/08/WhatsApp-Image-2026-08-10-at-10.50.47.jpeg",
  alt: "BITSF",
  caption: "BREAK IN THROUGH - SHORT FILM",
  credits: "Music - Sound Design - Mixing - Dialogue Cleanup - Additional Editing",
  link: "https://www.youtube.com/watch?v=tFnnEttcTmM"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/website-cover-scaled.jpg?v=z1m38jm8cne",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/FINAL-Portada-scaled.png?v=ppgfkshqkk-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/FINAL-Portada-scaled.png?v=7nr9bjeibo-wvc-sizes",
  alt: "Ether Dreams Album Cover",
  caption: "COFFEE WITH MILK - SHORT FILM",
  credits: "Soundtrack - Dialogue Cleanup - LINK PENDING",
  link: "#"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/Content-final.png?v=9amj1nosndh",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Cover-FINAL-scaled.png?v=kx7z3en4ses-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Cover-FINAL-scaled.png?v=4zb26fxnct2-wvc-sizes",
  alt: "Songwriting tips",
  caption: "SONGWRITING TIPS - YOUTUBE SERIES",
  credits: "Music - Mixing - Sound Design - Dialogue Cleanup",
  link: "https://youtube.com/playlist?list=PLsai2MhJ7NGRmGhVlpuSbsXvlTAfwER7V&si=ok3QwFP7vePgroum"
}, {
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/Acuerda.png?v=e5epn7q842i",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Mountain-Edits-Cover-FINAL-scaled.png?v=dqjveriqolr",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Mountain-Edits-Cover-FINAL-scaled.png?v=zl77h6g5zb",
  alt: "Acuerda",
  caption: "ACUERDA ESCUELA - TUTORIALS & CONTENT",
  credits: "Mixing - Sound Design - Dialogue Cleanup - 5 Videos",
  link: "https://www.instagram.com/acuerda.escuela?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
}];
export default function StaticAlbumGallery() {
  return <section data-section-id="256222" id="static-album-gallery" className="text-foreground py-8 md:py-12 border-t border-border bg-background/40">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <h2 className="font-bold font-serif uppercase tracking-tighter mb-4 !text-3xl">SOUNDTRACKS & SOUND DESIGN</h2>
        <p className="font-mono text-sm md:text-base text-muted-foreground mb-8 md:mb-12 max-w-3xl uppercase tracking-wider"><span className="!font-sans" data-ast-id="f:/src/pages/Portfolio/sections/StaticAlbumGalleryCopy.tsx|sig:yzi4fj" data-ast-start="13914" data-ast-end="14151"><span className="!font-serif" data-ast-id="f:/src/pages/Portfolio/sections/StaticAlbumGalleryCopy.tsx|sig:2tk5ed" data-ast-start="13943" data-ast-end="14144" contenteditable="false" style={{}}>MUSIC & AUDIO FOR VISUAL MEDIA. HOVER THE MOUSE OVER EACH IMAGE FOR SPECIFIC CREDITS AND CLICK TO LISTEN OR FIND OUT MORE</span></span></p>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {galleryImages.map((image, i) => <Link key={i} to={image.link} newTab data-index={i} className="group relative overflow-hidden rounded-md shadow-md bg-card">
              <AspectRatio ratio={1 / 1}>
                <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-4">
                  <span className="text-primary font-default text-sm md:text-base font-semibold text-center tracking-tight uppercase">
                    {image.caption}
                  </span>
                  {image.credits && <p className="text-primary/80 font-default text-xs text-center mt-1">
                      {image.credits}
                    </p>}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-secondary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none mix-blend-overlay" />
              </AspectRatio>
            </Link>)}
        </div>
      </div>
    </section>;
}